// extracted by mini-css-extract-plugin
module.exports = {"employeesListWrapper":"_1BXWX","employeesListTitle":"_3Zn07","employeesList":"_2g9Im","employeesItem":"CucDT"};